<template>
    <div class="modal show">
        <div class="modal-backdrop show" :style="{ zIndex: 'unset' }" @click.self="close()"></div>

        <section :style="{ zIndex: 1 }">
            <div class="modal-dialog modal-sm popup">
                <div class="modal-content">
                    <div class="modal-header mb-0">
                        <div class="modal-title">
                            {{ trans('Choose update option') }}
                        </div>

                        <button
                            type="button"
                            class="close"
                            data-dismiss="modal"
                            aria-label="Close"
                            @click="close()"
                        >
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>

                    <div class="modal-body">
                        <form class="rc-form">
                            <div class="row">
                                <div class="col-12">
                                    <div class="custom-control custom-radio permission-radio">
                                        <input
                                            type="radio"
                                            value="this"
                                            id="this"
                                            name="updateOption"
                                            class="custom-control-input"
                                            v-model="form.updateOption"
                                        />
                                        <label class="custom-control-label mt-2" for="this">
                                            {{ trans('This event') }}
                                        </label>
                                    </div>

                                    <div class="custom-control custom-radio permission-radio">
                                        <input
                                            type="radio"
                                            value="following"
                                            id="following"
                                            name="updateOption"
                                            class="custom-control-input"
                                            v-model="form.updateOption"
                                        />
                                        <label
                                            class="custom-control-label mt-2 mr-1"
                                            for="following"
                                        >
                                            {{ trans('This and following events') }}
                                        </label>
                                    </div>

                                    <div
                                        class="custom-control custom-radio permission-radio"
                                        v-if="all_update_option"
                                    >
                                        <input
                                            type="radio"
                                            value="all"
                                            id="all"
                                            name="updateOption"
                                            class="custom-control-input"
                                            v-model="form.updateOption"
                                        />
                                        <label class="custom-control-label mt-2 mr-1" for="all">
                                            {{ trans('All events') }}
                                        </label>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                    <!-- modal-body -->

                    <div class="modal-footer">
                        <button @click="update()" class="btn btn-secondary">{{ trans('save') }}</button>
                    </div>
                </div>
                <!--/ modal-content -->
            </div>
        </section>
    </div>
</template>

<script>
import { Form } from '../../../classes/Form';

export default {
    name: 'UpdateRepeatedSlotsComponent',
    data() {
        return {
            dateFormat: 'dd-mm-yyyy',
            form: new Form({
                updateOption: 'this',
            }),
        };
    },
    props: {
        slot_id: {
            required: true,
            default: null,
        },
        all_update_option: {
            required: true,
            default: true,
        },
    },
    methods: {
        close() {
            // Cleanup
            this.form.updateOption = 'this';
            this.$emit('close', true);
        },
        update() {
            this.$emit('update', this.form.updateOption);
        },
    },
};
</script>
